import(/* webpackMode: "eager" */ "/workspace/impact-ot/src/app/global-error.tsx");
